export const getRoutePath = (route: string) => {
  if (route.startsWith('/admin/')) {
    const lastWord = route.split('/').splice(-1).toString();
    return lastWord;
  }
  return route;
};
